import { ArrowLeft,ArrowRight,BookOpenText,Eye,MessageCircleQuestionMark,RotateCw,Share2,Volume2 } from "lucide-react";
import type { MouseEvent as TargetedMouseEvent } from "react";
import readingFox from "../../assets/reading-fox.png";
export const DIFFICULTIES = [
  { value: "easy", label: "קצר" },
  { value: "medium", label: "בינוני" },
  { value: "hard", label: "ארוך" },
] as const;

export const LANGUAGES = [
  { value: "he", label: "עברית" },
  { value: "en", label: "אנגלית" },
] as const;

export const ENGLISH_LEVELS = [
  { value: "starter", label: "מתחילים" },
  { value: "basic", label: "בסיסי" },
  { value: "advanced", label: "בסיסי מורחב" },
] as const;

const ICONS = {
  bookOpenText: BookOpenText,
  volume: Volume2,
  refresh: RotateCw,
  previous: ArrowRight,
  next: ArrowLeft,
  questions: MessageCircleQuestionMark,
  share: Share2,
  reveal: Eye,
} as const;

export const SPEECH_SUPPORTED = "speechSynthesis" in window && "SpeechSynthesisUtterance" in window;

type InlineIconProps = {
  name: keyof typeof ICONS;
  className?: string;
};

export function InlineIcon({ name, className = "" }: InlineIconProps) {
  const Icon = ICONS[name];
  return (
    <span className={`app-icon ${className}`} aria-hidden="true">
      <Icon aria-hidden="true" focusable="false" strokeWidth={2.4} />
    </span>
  );
}

export function ReadingFox() {
  return (
    <img
      className="reading-fox"
      src={readingFox}
      alt=""
      aria-hidden="true"
      draggable={false}
    />
  );
}

export function Loader({ message = "מכינים לך טקסט..." }: { message?: string }) {
  return (
    <div className="loader" role="status" aria-live="polite">
      <ReadingFox />
      <p>{message}</p>
      <div className="loader__dots" aria-hidden="true">
        <i />
        <i />
        <i />
      </div>
    </div>
  );
}

export function scrollToTop() {
  document.querySelector<HTMLElement>(".reading-root .main")?.scrollTo({ top: 0 });
}

type NextButtonProps = {
  done: boolean;
  label: string;
  icon: keyof typeof ICONS;
  progress: number;
  disabled?: boolean;
  onClick: (event: TargetedMouseEvent<HTMLButtonElement>) => void;
};

// The big "next" button of the reader and quiz docks; mint once the screen is done.
export function NextButton({ done, label, icon, progress, disabled, onClick }: NextButtonProps) {
  return (
    <button
      className={`next-button ${done ? "next-button--done" : ""}`}
      type="button"
      disabled={disabled}
      onClick={onClick}
      onAnimationEnd={(event) => (
        event.animationName === "reading-next-hop"
        && event.currentTarget.classList.remove("is-advancing")
      )}
    >
      <span className="next-button__text">{label}</span>
      <span className="next-button__cue" aria-hidden="true">
        <InlineIcon className="next-button__arrow" name={icon} />
      </span>
      <span className="next-button__progress" aria-hidden="true">
        <span style={{ width: `${progress}%` }} />
      </span>
    </button>
  );
}

